var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDelete = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 70,
  height: 70,
  viewBox: "0 0 70 70"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M35 0a35 35 0 1 0 35 35A35 35 0 0 0 35 0m0 68a33 33 0 1 1 33-33 33 33 0 0 1-33 33"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M33.5 18.22h3v25h-3z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 50.03,
  r: 2.5,
  fill: "currentColor"
})));
export default SvgDelete;